import { createBrowserRouter } from 'react-router'
import Home from '@/router/Home'
import SellerFormLayout from './components/layouts/form-layout/SellerFormLayout'
import MerchantFormInfo from '@/router/merchant-form/Info'
import Address from '@/router/merchant-form/Address'
import CategoryForm from '@/router/merchant-form/Category'
import RegisterStatus from './router/merchant-form/RegisterStatus'
import ContractForm from './router/merchant-form/Contract'
import PrivateRoute from './router/PrivateRoute'
import DocumentUploadForm from '@/router/merchant-form/DocumentUpload'
import NotFound from './router/NotFound'
import ServerError from './router/ServerError'
import ContractPreviewPage from './components/forms/contract/ContractPreviewPage'

const router = createBrowserRouter([
  {
    path: '/',
    Component: Home,
    errorElement: <ServerError />
  },
  {
    path: '/merchant-register',
    Component: PrivateRoute,
    children: [
      {
        path: '',
        Component: SellerFormLayout,
        children: [
          { path: 'info', Component: MerchantFormInfo },
          { path: 'category', Component: CategoryForm },
          { path: 'contract', Component: ContractForm },
          { path: 'address', Component: Address },
          { path: 'document-upload', Component: DocumentUploadForm }
        ],
        errorElement: <ServerError />
      },
      {
        path: 'status',
        Component: RegisterStatus,
        errorElement: <ServerError />
      }
    ]
  },
  {
    path: '/contract/preview',
    Component: ContractPreviewPage
  },
  {
    path: '*',
    Component: NotFound
  }
])

export default router
